.root {
  display: flex;
  background: #fff;
}

.positionStatic {
  position: static;
}

.positionAbsolute {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.fullWidth {
  width: 100%;
}

.gutters {
  padding: 8px 16px;
}

.loader {
  color: var(--action-active);
}
